/* ==========================================================================
   ProductCardHe > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'ProductCardHe',
    init: true,
    start: true,
    css: {
        self: 'product-card-he',
        soldOut: 'product-card-he--sold-out',
        price: 'product-card-he__price',
        company: 'product-card-he__company',
        priceOffer: 'product-card-he__price-offer',
        active: 'is-active',
        modal: 'modal-rxjs--product-card',
        info: 'modal-rxjs-info',
        searcher: 'modal-rxjs-searcher',
        accordion: 'accordion',
        features: 'features',
        tooltip: 'tooltip--product-card-he',
        imageTripadvisor: 'image-rxjs--tripadvisor'
    },
    type: {
        image: 'product-card-he-image',
        company: 'product-card-he-company',
        navButton: 'product-card-he-nav-button',
        tooltip: 'product-card-he-nav-tooltip',
        modal: 'product-card-he-modal',
        imageModal: 'product-card-he-modal-image',
        imageTripadvisor: 'product-card-he-image-tripadvisor',
        searcher: 'product-card-he-searcher'
    },
    hooks: {
        link: 'data-link',
        tooltip: 'data-tooltip',
        searcher: 'data-searcher',
        searcherSkeletor: 'data-searcher-skeletor',
        price: 'data-price',
        loader: 'data-loader'
    },

    deal: false,
    moreInfoTitle: false,
    tabsSameHeight: true,
    rating: 'star',
    product: 'FLIGHTHOTEL',
    hasModal: false,
    noPrice: true
};

module.exports = () => config;
